import React from "react";
import TransactionsBreadCrumb from "../../Components/Transactions/TransactionsBreadCrumb";
import TransactionsListings from "../../Components/Transactions/TransactionsListings";

export default function TransactionsListing() {
  return (
    <React.Fragment>
      <div className="page-content">
        <TransactionsBreadCrumb />
        <TransactionsListings />
      </div>
    </React.Fragment>
  );
}
